module.exports = __webpack_public_path__ + "static/img/06.b6b4ed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/06.png
// module id = zdkV
// module chunks = 2